/**
 * Main Layout - Sidebar + Header + Content
 */

import { useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { PageTransition } from '@/components/motion';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ImpersonationBanner } from './ImpersonationBanner';

export function MainLayout() {
  const storageKey = 'nord-living:sidebar-collapsed';
  const initialCollapsed = useMemo(() => {
    if (typeof window === 'undefined') return false;
    return window.localStorage.getItem(storageKey) === '1';
  }, []);

  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(initialCollapsed);
  const location = useLocation();

  useEffect(() => {
    try {
      window.localStorage.setItem(storageKey, sidebarCollapsed ? '1' : '0');
    } catch {
      // ignore storage errors
    }
  }, [sidebarCollapsed]);

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar collapsed={sidebarCollapsed} />
      <div className="flex flex-1 flex-col overflow-hidden">
        <ImpersonationBanner />
        <Header
          sidebarCollapsed={sidebarCollapsed}
          onToggleSidebar={() => setSidebarCollapsed((v) => !v)}
        />
        <main className="flex min-h-0 flex-1 flex-col min-w-0 overflow-y-auto overflow-x-hidden bg-muted/30">
          <div className="flex flex-col p-4 sm:p-6">
            <PageTransition key={location.pathname}>
              <Outlet />
            </PageTransition>
          </div>
        </main>
      </div>
    </div>
  );
}
